
import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/views/common/MenuView'
import PageView from '@/views/common/PageView'
import LoginView from '@/views/login/Common'
import ForgetView from '@/views/login/Forget'
import ForgetSuccessView from '@/views/login/ForgetSuccess'
import EmptyPageView from '@/views/common/EmptyPageView'
import setting from '../settings'
import db from 'utils/localstorage'
import request from 'utils/request'

Vue.use(Router)

let constRouter = [
  {
    path: '/login',
    name: '登录页',
    meta: {notAllowToken: true},
    component: LoginView
  },
  {
    path: '/forget',
    name: '忘记密码页',
    meta: {notAllowToken: true},
    component: ForgetView
  },
  {
    path: '/forget_success',
    name: '重置密码成功页',
    meta: {notAllowToken: true},
    component: ForgetSuccessView
  },
  {
    path: '/index',
    name: '首页',
    redirect: '/home'
  }
]

let router = new Router({
  routes: constRouter
})

const whiteList = ['/login']

let asyncRouter

let HomePageView

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  }
  let token = db.get('USER_TOKEN')
  let user = db.get('USER')
  let userRouter = get('USER_ROUTER')
  if (token.length && user) {
    let systemName = setting.systemName
    if (to.meta.title) {
      document.title = to.meta.title + ' | ' + systemName
    } else {
      document.title = systemName
    }
    if (!userRouter) {
      request.get(`menus?t=` + new Date()).then((res) => {
        asyncRouter = res.data
        if (setting.menuPageSkip && setting.menuPageSkip.flag) {
          let pathParam = ''
          if (Object.keys(setting.menuPageSkip.pathParams).length > 0) {
            for (let key in setting.menuPageSkip.pathParams) {
              pathParam += `&${key}=${setting.menuPageSkip.pathParams[key]}`
            }
          }
          asyncRouter[0].children.push({
            component: 'HomePageView',
            icon: setting.menuPageSkip.icon,
            meta: {SSOFlag: true},
            name: setting.menuPageSkip.name,
            path: `${setting.menuPageSkip.path}?token=${token}${pathParam}`
          })
        }
        save('USER_ROUTER', asyncRouter)
        go(to, next)
      })
    } else {
      if (!asyncRouter) {
        asyncRouter = userRouter
        go(to, next)
      } else {
        next()
      }
    }
  } else {
    if (to.meta.notAllowToken) {
      next()
    } else {
      if (to.query.cid) {
        next({path: '/login', query: {cid: to.query.cid}})
      } else {
        next('/login')
      }
    }
  }
})

function go (to, next) {
  // 初始化异步router，添加大屏全屏化route
  pushFullScreenRoute(asyncRouter, asyncRouter)
  asyncRouter = filterAsyncRouter(asyncRouter)
  router.addRoutes(asyncRouter)
  next({...to, replace: true})
}

function save (name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}

function get (name) {
  return JSON.parse(localStorage.getItem(name))
}

function pushFullScreenRoute (arr, asyncRouter) {
  arr.forEach(element => {
    if (element.component === 'HomePageView') {
      HomePageView = view('views/dashboard/HomePage.vue')
      element.meta.fullPageContent = true
    }
    if (element.meta && !element.children) {
      if (element.meta.bigScreenPath) {
        let bigScreenPath = db.get('BIG_SCREEN_PATH') || {}
        bigScreenPath[Object.keys(bigScreenPath).length] = element.meta.bigScreenPath
        save('BIG_SCREEN_PATH', bigScreenPath)
        asyncRouter.push({
          appCode: element.appCode,
          path: element.meta.bigScreenPath,
          name: element.name + 'FullScreen',
          component: element.component,
          meta: {
            title: element.name,
            FullScreen: true
          }
        })
      }
    } else if (element.children) {
      pushFullScreenRoute(element.children, asyncRouter)
    }
  })
}

function filterAsyncRouter (routes) {
  return routes.filter((route) => {
    let component = route.component
    if (component) {
      switch (route.component) {
        case 'MenuView':
          route.component = MenuView
          break
        case 'PageView':
          route.component = PageView
          break
        case 'EmptyPageView':
          route.component = EmptyPageView
          break
        case 'HomePageView':
          route.component = HomePageView
          break
        default:
          route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      if (route.meta) {
        route.meta.title = route.meta.title || route.name
      }
      return true
    }
  })
}

function view (path) {
  return function (resolve) {
    console.log(path)
    import(`@/${path.substr(0, path.length - 4)}.vue`).then(mod => {
      resolve(mod)
    }).catch(error => {
      const pattern = /Loading chunk (\d)+ failed/g
      const isChunkLoadFailed = error.message.match(pattern)
      if (isChunkLoadFailed) {
        let refreshFlag = confirm('当前系统版本已更新，请刷新页面获取最新版本')
        if (refreshFlag) {
          window.location.reload()
        }
      }
    })
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js